import { create } from "zustand";
import { logger } from "./logger";
const initialState = {
    deletePolygonIdInfo: null,
    geofenceList: [],
    projectId: "",
    projectName: "",
    selectedGeoFenceId: null,
    selectedPolygonType: "none",
    updatePolygonId: null,
    updatedGeoFencePath: null
};
const useProjectGeoFenceStore = create()(logger((set, get) => ({
    ...initialState,
    deleteGeofence: (geofenceId) => {
        set((state) => ({
            geofenceList: state.geofenceList.filter((g) => g.geofenceId !== geofenceId)
        }));
    },
    getGeofenceCoordinates: (geofenceId) => {
        const geofence = get().geofenceList?.find((g) => g.geofenceId === geofenceId);
        return geofence?.coordinates;
    },
    getGeofenceInfo: (geofenceId) => {
        const geofence = get().geofenceList?.find((g) => g.geofenceId === geofenceId);
        return geofence;
    },
    getGeofenceModeType: (geofenceId) => {
        const geofence = get().geofenceList?.find((g) => g.geofenceId === geofenceId);
        return geofence?.modeType;
    },
    getGeofenceName: (geofenceId) => {
        const geofence = get().geofenceList?.find((g) => g.geofenceId === geofenceId);
        return geofence?.geofenceName;
    },
    getGeofenceType: (geofenceId) => {
        const geofence = get().geofenceList?.find((g) => g.geofenceId === geofenceId);
        return geofence?.geofenceType;
    },
    resetDeletePolygonId: () => {
        set(() => ({ deletePolygonIdInfo: null }));
    },
    resetGeofenceState: () => {
        set(() => ({
            deletePolygonIdInfo: null,
            geofenceList: [],
            projectId: null,
            projectName: null,
            selectedGeoFenceId: null,
            selectedPolygonType: "none",
            updatePolygonId: null,
            updatedGeoFencePath: null
        }));
    },
    resetUpdatePolygonId: () => {
        set(() => ({ updatePolygonId: null }));
    },
    setDeletePolygonIdInfo: (info) => {
        set(() => ({ deletePolygonIdInfo: info }));
    },
    setGeofenceCoordinates: (geofenceId, coordinates) => {
        set((state) => ({
            geofenceList: state.geofenceList.map((g) => g.geofenceId === geofenceId ? { ...g, coordinates } : g)
        }));
    },
    setGeofenceDesc: (geofenceId, description) => {
        set((state) => ({
            geofenceList: state.geofenceList.map((g) => g.geofenceId === geofenceId ? { ...g, description } : g)
        }));
    },
    setGeofenceIdModeType: (tempGeofenceId, newGeofenceId) => {
        set({
            geofenceList: get().geofenceList.map((g) => g.geofenceId === tempGeofenceId ? { ...g, geofenceId: newGeofenceId, modeType: "edit" } : g)
        });
    },
    setGeofenceList: (newGeoFences) => {
        set((state) => {
            // Merge by geofenceId instead of blindly appending so re-hydrating the same
            // server data (e.g. remounting the geofence step after navigating away) updates
            // existing entries in place rather than duplicating them on the map.
            const merged = state.geofenceList.map((existing) => {
                const updated = newGeoFences.find((next) => next.geofenceId === existing.geofenceId);
                return updated ? { ...existing, ...updated } : existing;
            });
            const existingIds = new Set(state.geofenceList.map((g) => g.geofenceId));
            const additions = newGeoFences.filter((next) => !existingIds.has(next.geofenceId));
            return { geofenceList: [...merged, ...additions] };
        });
    },
    setGeofenceName: (geofenceId, geofenceName) => {
        set((state) => ({
            geofenceList: state.geofenceList.map((g) => g.geofenceId === geofenceId ? { ...g, geofenceName } : g)
        }));
    },
    setGeofenceType: (geofenceId, geofenceType) => {
        set((state) => ({
            geofenceList: state.geofenceList.map((g) => g.geofenceId === geofenceId ? { ...g, geofenceType } : g)
        }));
    },
    setProjectGeofenceInfo: (projectGeofenceInfo) => {
        set(() => ({
            geofenceList: projectGeofenceInfo.geofenceList,
            projectId: projectGeofenceInfo.projectId,
            projectName: projectGeofenceInfo.projectName
        }));
    },
    setSelectedGeoFenceId: (geofenceId) => {
        set(() => ({ selectedGeoFenceId: geofenceId }));
    },
    setSelectedPolygonType: (polygonType) => {
        set(() => ({ selectedPolygonType: polygonType }));
    },
    setUpdatePolygonId: (info) => {
        set(() => ({ updatePolygonId: info }));
    },
    setUpdatedGeoFencePath: (path) => {
        set(() => ({ updatedGeoFencePath: path }));
    }
}), "ProjectGeoFenceStore"));
export default useProjectGeoFenceStore;
